import "../css/home.css";
import About from "../sections/About";
import Contact from "../sections/Contact";
import Reviews from "../sections/Reviews";
import Services from "../sections/Services";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";

export default function Home() {
  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from(".statement-container", {
      scrollTrigger: {
        trigger: ".statement-container",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
    });

    gsap.from(".logo-container", {
      scrollTrigger: {
        trigger: ".logo-container",
      },
      opacity: 0,
      duration: 1.65,
      ease: "power3.out",
      y: 30,
    });
  });

  return (
    <>
      <section className="home">
        <div className="banner-container">
          <div className="overlay">
            <div className="mission-container">
              <div className="mission-header">
                <h3 className="mission-statement">Our mission</h3>
              </div>
              <div className="statement-container">
                <h3 className="mission-statement">
                  At Lawrence Trust and Estate Law, we help families protect
                  their wealth and plan for tomorrow. With personalized estate
                  and tax solutions, we provide clear guidance and compassionate
                  support, empowering clients to navigate complex legal matters
                  with confidence and peace of mind. We offer transparent and
                  reasonable pricing, with military discounts for our fellow
                  service families.
                </h3>
              </div>
              <div className="logo-container">
                <img src="/logo-removebg.png" alt="" />
                <h5 className="mission-statement">
                  Hilary Lawrence | Attorney at Law
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Services />
      <About />
      <Contact />
      <Reviews />
    </>
  );
}
